var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("AttachmentTemplatesDialog.title"),
        visible: _vm.visible,
        "before-close": _vm.handleClose,
        width: "480px"
      }
    },
    [
      _c(
        "el-table",
        { attrs: { data: _vm.templates } },
        [
          _c("el-table-column", {
            attrs: {
              prop: "document_name",
              label: _vm.$t("AttachmentTemplatesDialog.document_name"),
              width: "240"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "locale",
              label: _vm.$t("AttachmentTemplatesDialog.locale"),
              width: "50"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.handleChooseTemplate(scope.row)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.$t("AttachmentTemplatesDialog.choose")) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }